<div class="row" style="margin-top: 100px;">

    <div class="col">

        <label *ngIf="!companyHaveData">{{companyMessage}}</label>

        <table class="table" *ngIf="companyHaveData">
            <thead>
                <tr>
                    <th scope="col">Servidor de conexión</th>
                    <th scope="col">Nombre Compañía</th>
                    <th scope="col">Base de Datos</th>
                    <th scope="col">Activo</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let company of companyList">
                    <td>{{ company.Server }}</td>
                    <td>{{ company.DBName }}</td>
                    <td>{{ company.DBCode }}</td>
                    <td><input type="checkbox" [(ngModel)]="company.Active"></td>
                </tr>
            </tbody>
        </table>

    </div>

</div>